exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loader{margin:auto;width:60px}.loader img{width:60px;background:rgba(0,0,0,.15);border-radius:50%;padding:10px}", ""]);

// exports
